import { jsxs, jsx } from "react/jsx-runtime";
import { B as Box } from "./Grid-CcQKdsgp.js";
const Image = (props) => {
  const { value, mdValue, dValue, image, className = "", ...rest } = props;
  return /* @__PURE__ */ jsxs(Box, { className: `${className != null ? className : ""}`, ...rest, as: "picture", children: [
    /* @__PURE__ */ jsx("source", { media: "(min-width: 1024px)", srcSet: dValue, type: "image/webp" }),
    /* @__PURE__ */ jsx("source", { media: "(min-width: 768px)", srcSet: mdValue, type: "image/webp" }),
    /* @__PURE__ */ jsx("img", { src: value, alt: "image", className: "w-full", ...image })
  ] });
};
export {
  Image
};
